import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n, I18nKey } from 'i18n'
import { observer } from 'mobx-react-lite'
import { Page } from 'page/Page/Page'
//import { store } from 'store/store'
import { ItemsPane } from 'page/StartScreen/ItemsPane'
import css from './BasicNoLimitScreen.module.scss'

export const BasicNoLimitScreen = observer(() => {
  const exceededLimitType = 'ACCESS_KEY_USER_DAY'//store.exceededLimitType || ''
  const limitText = i18n(`LimitTextShot${exceededLimitType}` as I18nKey)
  const limitTextTryAgain = i18n(`LimitTextTryAgain${exceededLimitType}` as I18nKey)

  return (
    <Page full center>
      <Vertical maxWidth="var(--max-width)" pad={[20, 40]} gap={24} tall center>
        <Vertical minWidth={240} wide tall oh>
          <ItemsPane />
        </Vertical>
        <Vertical wide pad={12} gap={4} center className={css.limit}>
          <Typo center semi>{limitText}</Typo>
          <Typo center>{limitTextTryAgain}</Typo>
        </Vertical>
      </Vertical>
    </Page>
  )
})
